import styled from 'styled-components';

import Button from '@components/Button/next';

export const Container = styled.div``;

export const Header = styled.h1`
  padding: 0px;
  margin: 0px;
  line-height: normal;
  margin-bottom: 16px;
  text-decoration: none !important;
  text-indent: 0 !important;
  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
    margin-left: 15px;
  }
`;

export const SubHeader = styled.div<{ marginTop?: number }>`
  margin-top: ${({ marginTop }) => (marginTop ? marginTop + 'px' : '0')};
  line-height: normal;
  letter-spacing: 1px;
`;

export const ContentWrapper = styled.div`
  padding: 20px;
  background-color: ${({ theme }) => theme.palette.lynxWhite};
  max-width: 960px;
  display: grid;
  grid-row-gap: 10px;
  border-radius: 8px;
  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
    padding: 0px;
  }
`;

export const FormItemCol = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-column-gap: 20px;
  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
    grid-template-columns: 1fr;
    grid-row-gap: 20px;
  }
`;

export const FormWrapper = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  grid-row-gap: 20px;
`;

export const ApplyButton = styled(Button)`
  && {
    height: 58px;
    font-weight: bold;
    font-size: 16px;
    @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
      width: 100% !important;
    }
  }
`;

ApplyButton.defaultProps = {
  variant: 'Primary',
};

export const InfoContainer = styled.div<{ padding?: number }>`
  padding: ${({ padding }) => padding ?? 20}px;
  background-color: ${({ theme }) => theme.palette.white};
  width: 100%;
  max-width: 920px;
  display: grid;
  grid-row-gap: 12px;
  border-radius: 8px;
  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
    max-width: 100vw;
  }
`;

export const WarningMessageContainer = styled.span`
  padding: 12px 15px;
  border-radius: 8px;
  background-color: rgba(27, 117, 226, 0.1);
  display: flex;
  align-items: center;
  width: 100%;
  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
    padding: 14px 19px 11px 6px;
  }
`;

export const WarningMessageText = styled.span`
  font-size: 14px;
  color: ${({ theme }) => theme.palette.clearBlue};
  margin-left: 12px;
  & a {
    color: ${({ theme }) => theme.palette.clearBlue};
  }
  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
    margin-left: 6px;
    font-size: 12px;
    font-weight: 600;
    line-height: normal;
  }
`;

export const InfoIconWrapper = styled.div`
  align-self: flex-start;
`;

export const InfoCardContainer = styled.div``;
